export var CarrierNotAvailable = function CarrierNotAvailable(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getDescription();
    }
  };
};
var CarrierNotAvailableBuilder = function CarrierNotAvailableBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "OmGYKr",
        defaultMessage: [{
          "type": 0,
          "value": "Transportadora indisponível"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "0tajdp",
        defaultMessage: [{
          "type": 0,
          "value": "A transportadora que selecionou não realiza envios para o endereço para o qual pretende enviar. Pode selecionar outra transportadora ou escolher a opção Enviar por conta própria."
        }]
      })];
    }
  };
};